module.exports = __webpack_public_path__ + "media/icons/Vectordownload-1a714c21.svg";